import React from "react";
import { string } from "prop-types";
import cx from "classnames";

const propTypes = {
  /** Html element. */
  tag: string,
};

const CLASS_ROOT = "grid";

const Grid = ({ className, tag = "div", ...other }) => {
  const classes = cx(CLASS_ROOT, className);
  const TagName = tag;

  return <TagName className={classes} {...other} />;
};

Grid.displayName = "Grid";
Grid.propTypes = propTypes;

export default Grid;
